module.exports = __webpack_public_path__ + "static/media/dlike.81d2077b.webp";